import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../../utils/api';

export default function CustomSections() {
  const { pathname } = useLocation();
  const [sections, setSections] = useState([]);

  useEffect(() => {
    api.get('/settings/public').then(({ data }) => {
      const s = data.settings || {};
      let parsed = [];
      try { parsed = s.homepage_custom_sections ? JSON.parse(s.homepage_custom_sections) : []; } catch {}
      setSections(parsed);
    }).catch(() => {});
  }, []);

  const matching = sections.filter(sec => {
    if (!sec.content) return false;
    const pages = (sec.pages || '/').split(',').map(p => {
      p = p.trim();
      if (!p.startsWith('/')) p = '/' + p;
      return p;
    });
    return pages.some(p => {
      if (p === '/') return pathname === '/';
      return pathname === p || pathname.startsWith(p + '/');
    });
  });

  if (!matching.length) return null;

  return (
    <>
      {matching.map(sec => (
        <section key={sec.id} className="max-w-7xl mx-auto px-4 py-6">
          <div className="rounded-3xl p-8 md:p-12" style={{ backgroundColor: sec.bg || '#f9fafb' }}>
            <div
              className="prose prose-sm max-w-none text-gray-700 [&_h1]:text-2xl [&_h1]:font-bold [&_h2]:text-xl [&_h2]:font-bold [&_h3]:text-lg [&_h3]:font-semibold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-1 [&_a]:text-brand-yellow [&_a]:underline [&_strong]:font-bold [&_em]:italic [&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-gray-500 [&_table]:w-full [&_td]:border [&_td]:border-gray-200 [&_td]:px-3 [&_td]:py-2 [&_th]:border [&_th]:border-gray-200 [&_th]:px-3 [&_th]:py-2 [&_th]:bg-gray-50 [&_th]:font-semibold"
              dangerouslySetInnerHTML={{ __html: sec.content }}
            />
            {sec.link_text && sec.link_url && (
              <div className="mt-6">
                {sec.link_url.startsWith('http') ? (
                  <a href={sec.link_url} target="_blank" rel="noreferrer"
                    className="inline-block btn-primary rounded-full px-8 py-3 text-base font-bold">
                    {sec.link_text}
                  </a>
                ) : (
                  <Link to={sec.link_url}
                    className="inline-block btn-primary rounded-full px-8 py-3 text-base font-bold">
                    {sec.link_text}
                  </Link>
                )}
              </div>
            )}
          </div>
        </section>
      ))}
    </>
  );
}
